import React, { useEffect, useState } from 'react';

import { HorizontalNav } from '../../molecules';
import { makeClassNames } from '../../../utils/styles';
import { IIcon } from '../../atoms/icons/icon';
import IconArrowLeft from '../../atoms/icons/icon-arrow-left';
import IconArrowRight from '../../atoms/icons/icon-arrow-right';
import './glider.scss';

const iconLeft = (): React.ReactElement<IIcon> => <IconArrowLeft size="xxxsmall" color="blue" />;
const iconRight = (): React.ReactElement<IIcon> => <IconArrowRight size="xxxsmall" color="blue" />;

const classNames = () => {
  return makeClassNames({
    nav: ['predicted-lineups-hp__nav', 'glid__contain'],
    navList: 'predicted-lineups-hp__nav-list',
    navItem: 'predicted-lineups-hp__nav-item',
    navItemDisabled: 'predicted-lineups-hp__nav-item--disable',
    navArrowLeft: 'predicted-lineups-hp__nav-arrow-left',
    navArrowRight: 'predicted-lineups-hp__nav-arrow-right',
  });
};

const GliderItem = (props: {
  item: any;
  onSelectedGliderItem: any;
  className: string;
  index: any;
  disabled: boolean;
}) => {
  const { item, onSelectedGliderItem, className, index, disabled } = props;
  const cn = classNames();
  const handleClick = (params: { index: number }) => {
    const { index } = params;
    if (disabled) {
      return;
    }
    onSelectedGliderItem(index);
  };

  return (
    <HorizontalNav.Item
      index={index}
      className={disabled ? `${className} ${cn.navItemDisabled}` : className}
      onClick={() => handleClick({ index })}
      hasInnerLink
    >
      {item.itemState === 'disabled' ? <span>{item.label}</span> : <a href={item.href}>{item.label}</a>}
    </HorizontalNav.Item>
  );
};

const Glider = ({
  activeIndex = 0,
  items,
  onSelectedGliderItem,
}: {
  activeIndex?: number;
  items: {
    href?: string;
    label: React.ReactNode;
    itemState?: string;
  }[];
  onSelectedGliderItem: (id: number) => void;
}): JSX.Element => {
  const [isDesktop, setIsDesktop] = useState<boolean>(false);
  const cn = classNames();

  useEffect(() => {
    setIsDesktop(window.innerWidth >= 1024);
  }, []);

  return (
    <HorizontalNav
      className={cn.nav}
      listClassName={cn.navList}
      activeIndex={activeIndex}
      arrows={{
        show: true,
        width: isDesktop ? 40 : 8,
        left: { icon: iconLeft(), className: cn.navArrowLeft },
        right: { icon: iconRight(), className: cn.navArrowRight },
      }}
    >
      {items.map((item, index) => (
        <GliderItem
          key={item.href}
          item={item}
          onSelectedGliderItem={onSelectedGliderItem}
          className={cn.navItem}
          index={index}
          disabled={item.itemState === 'disabled'}
        />
      ))}
    </HorizontalNav>
  );
};

export default Glider;
